import React from "react";

import { Container } from "@components/Container/Container";

import styles from "./styles.module.scss";
import { Text } from "@components/Text/Text";
import { Box } from "@components/Box/Box";
import { ImageField } from "@helpers/interfaces/image";
import { Heading } from "@components/Heading/Heading";
import classnames from "classnames";
import Anime from "react-anime";
import { animeChildrenProps } from "@helpers/animations";
import { UmbracoImage } from "@components/Image/UmbracoImage/UmbracoImage";
import { useInView } from "react-intersection-observer";

interface infoProps {
  Key: string;
  Image: ImageField;
  Headline: string;
  BodyText: string;
}

export interface InfoGraphicsProps {
  infoGraphics: infoProps[];
  title?: string;
  large: boolean;
}

const InfoGraphics: React.FC<InfoGraphicsProps> = ({
  infoGraphics,
  title,
  large,
  ...props
}) => {
  const { ref, inView } = useInView({
    threshold: 0.2
  });
  const animateEachChild = {
    ...animeChildrenProps,
    ...(inView ? { autoplay: true } : { autoplay: false })
  };
  return (
    <div ref={ref} {...props}>
      <Container {...(!large && { variant: "medium" })}>
        <Box
          className={classnames(
            styles.infoGraphics,
            large ? styles.infoGraphicsBroad : styles.infoGraphicsSmall
          )}
        >
          {title && <Heading as="h2">{title}</Heading>}
          <Box
            className={classnames(
              styles.infoGraphicsList,
              !large && styles.infoGraphicsListSmall
            )}
          >
            <Anime {...animateEachChild}>
              {infoGraphics &&
                infoGraphics.map((info: infoProps) => {
                  const onlyOneItem =
                    (!info.Headline && info.Image) ||
                    (info.Headline && !info.Image);
                  return (
                    <Box
                      key={info.Key}
                      className={classnames(
                        styles.infoGraphicsListCell,
                        onlyOneItem && styles.infoGraphicsListCentering
                      )}
                    >
                      <Box
                        className={classnames(
                          styles.infoGraphicsListHeader,
                          !info.Headline &&
                            styles.infoGraphicsListHeaderNoHeading
                        )}
                      >
                        {info.Headline && (
                          <Heading as="h3" className={styles.heading}>
                            {info.Headline}
                          </Heading>
                        )}
                        {info.Image && (
                          <UmbracoImage
                            image={info.Image}
                            width={large ? [140] : []}
                            isCover
                          />
                        )}
                      </Box>
                      {info.BodyText && (
                        <Text className={styles.bodyText}>{info.BodyText}</Text>
                      )}
                    </Box>
                  );
                })}
            </Anime>
          </Box>
        </Box>
      </Container>
    </div>
  );
};

export { InfoGraphics };
